import { createTheme, PaletteColorOptions } from '@mui/material/styles';
import { FORM_SURFACE_PRIMARY } from './embedTheme.constants';
import { ThemeMode } from './embedTheme.types';
import { SurfacePalette } from './cssPalette';

interface AppThemeOptions {
  mode: ThemeMode;
  primary: PaletteColorOptions;
  surfaces?: SurfacePalette;
}

const surfacePalette = (surfaces?: SurfacePalette) =>
  surfaces
    ? {
        background: { default: surfaces.background, paper: surfaces.paper },
        divider: surfaces.divider,
        text: { primary: surfaces.text, secondary: surfaces.textSecondary },
      }
    : {};

const surfaceComponents = (surfaces?: SurfacePalette) =>
  surfaces
    ? {
        MuiPaper: {
          styleOverrides: {
            root: { backgroundImage: 'none' },
          },
        },
        MuiDialog: {
          styleOverrides: {
            paper: { border: `1px solid ${surfaces.divider}` },
          },
        },
      }
    : {};

export const createAppTheme = ({ mode, primary, surfaces }: AppThemeOptions) =>
  createTheme({
    typography: {
      fontFamily:
        "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif",
    },
    palette: {
      mode,
      primary,
      secondary: {
        main: '#dc004e',
      },
      ...surfacePalette(surfaces),
    },
    components: {
      MuiContainer: {
        styleOverrides: {
          root: {
            paddingLeft: '0 !important',
            paddingRight: '0 !important',
            '@media (min-width: 600px)': {
              paddingLeft: '0 !important',
              paddingRight: '0 !important',
            },
          },
        },
      },
      ...surfaceComponents(surfaces),
    },
  });

export const formSurfaceTheme = createAppTheme({
  mode: 'light',
  primary: { main: FORM_SURFACE_PRIMARY },
});
